"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _XYFrame = require("./XYFrame");

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// components

var MiniMap = function MiniMap(props) {
  var interactivity = {
    start: props.brushStart,
    during: props.brush,
    end: props.brushEnd
  };

  if (props.xBrushable && props.yBrushable) {
    interactivity.brush = "xyBrush";

    if (props.xBrushExtent || props.yBrushExtent) {
      interactivity.extent = [[0, 0], [].concat(_toConsumableArray(props.size))];
    }
    if (props.xBrushExtent) {
      interactivity.extent[0] = props.xBrushExtent;
    }
    if (props.yBrushExtent) {
      interactivity.extent[1] = props.yBrushExtent;
    }
  } else if (props.xBrushable) {
    interactivity.brush = "xBrush";
    if (props.xBrushExtent) {
      interactivity.extent = props.xBrushExtent;
    }
  } else if (props.yBrushable) {
    interactivity.brush = "yBrush";
    if (props.yBrushExtent) {
      interactivity.extent = props.yBrushExtent;
    }
  }

  return _react2.default.createElement(_XYFrame2.default, _extends({}, props, { interaction: interactivity }));
};

MiniMap.propTypes = {
  brushStart: _propTypes2.default.func,
  brush: _propTypes2.default.func,
  brushEnd: _propTypes2.default.func,
  xBrushExtent: _propTypes2.default.array,
  yBrushExtent: _propTypes2.default.array,
  xBrushable: _propTypes2.default.bool,
  yBrushable: _propTypes2.default.bool
};

exports.default = MiniMap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/MiniMap.js
// module id = 331
// module chunks = 0